export default __webpack_public_path__ + "static/media/icon-drug.eabf7284.svg";